const initialState = {
  users: [],
  salesUsers: [],
  user: null,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case `SET_USERS`:
      return {
        ...state,
        users: action.data,
      }

    case `SET_SALES_USERS`:
      return {
        ...state,
        salesUsers: action.data,
      }

    case `SET_USER_BY_ID`:
      return {
        ...state,
        user: action.data,
      }
    default:
      return state
  }
}

export default userReducer
